
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea,
    Typography
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const SubfieldStructureManagementForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "cataloging.subfield_structure_management",
    parentItemTypesOptions,
    parentLibraryOptions,
    parentAuthorisedCategoryOptions,

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        if (!parentItemTypesOptions) {
            itemTypesController.getData({})
            libraryController.getData({})
            authorisedCategoryController.getData({})

        }
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const itemTypesController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const authorisedCategoryController = useCRUDController({ apiRoute: "/koha/authorised_values/category" })
    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                parentItemTypesOptions={parentItemTypesOptions ? parentItemTypesOptions : itemTypesController.ResponseData}
                                parentLibraryOptions={parentLibraryOptions ? parentLibraryOptions : libraryController.ResponseData}
                                parentAuthorisedCategoryOptions={parentAuthorisedCategoryOptions ? parentAuthorisedCategoryOptions : authorisedCategoryController.ResponseData}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "library",
    axiosMode,
    parentItemTypesOptions,
    parentLibraryOptions,
    parentAuthorisedCategoryOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <>
            <Row>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                    <Row>
                        <Col span={24}>
                            <Row>
                                <Col>
                                    <Typography.Title level={3}>
                                        {t('basic_constraints')}
                                    </Typography.Title>
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'tagsubfield']}
                                fieldKey={[field?.fieldKey ?? '', 'tagsubfield']}
                                label={t('tagsubfield')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >
                                <Input maxLength={1} disabled={axiosMode === "patch"} />
                            </Form.Item>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'liblibrarian']}
                                fieldKey={[field?.fieldKey ?? '', 'liblibrarian']}
                                label={t('liblibrarian')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >

                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'libopac']}
                                fieldKey={[field?.fieldKey ?? '', 'libopac']}
                                label={t('libopac')}
                                rules={[{ required: true, message: t('please_input_item') }]}

                            >
                                <Input />

                            </Form.Item>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'tab']}
                                fieldKey={[field?.fieldKey ?? '', 'tab']}
                                label={t('tab')}
                                extra={t('ignore_message')}
                            >
                                <Select
                                    allowClear={true}
                                    options={[
                                        {
                                            label: t('ignore'),
                                            value: '-1'
                                        },
                                        {
                                            label: 1,
                                            value: 1
                                        },
                                        {
                                            label: 2,
                                            value: 2
                                        },
                                        {
                                            label: 3,
                                            value: 3
                                        },
                                        {
                                            label: 4,
                                            value: 4
                                        },
                                        {
                                            label: 5,
                                            value: 5
                                        },
                                        {
                                            label: 6,
                                            value: 6
                                        },
                                        {
                                            label: 7,
                                            value: 7
                                        },
                                        {
                                            label: 8,
                                            value: 8
                                        },
                                        {
                                            label: 9,
                                            value: 9
                                        },
                                        {
                                            label: 10,
                                            value: 10
                                        },
                                    ]}
                                />
                            </Form.Item>
                        </Col>

                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'repeatable']}
                                fieldKey={[field?.fieldKey ?? '', 'repeatable']}
                                label={t('repeatable')}
                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'mandatory']}
                                fieldKey={[field?.fieldKey ?? '', 'mandatory']}
                                label={t('mandatory')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'important']}
                                fieldKey={[field?.fieldKey ?? '', 'important']}
                                label={t('important')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col>
                                    <Typography.Title level={3}>
                                        {t('advanced_constraints')}
                                    </Typography.Title>
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'defaultvalue']}
                                fieldKey={[field?.fieldKey ?? '', 'defaultvalue']}
                                label={t('defaultvalue')}

                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'maxlength']}
                                fieldKey={[field?.fieldKey ?? '', 'maxlength']}
                                label={t('maxlength')}
                            >
                                <InputNumber max={9999} />
                            </Form.Item>
                        </Col>

                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'isurl']}
                                fieldKey={[field?.fieldKey ?? '', 'isurl']}
                                label={t('isurl')}
                                extra={t('if_checked_subfield_is_url_clickable')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'seealso']}
                                fieldKey={[field?.fieldKey ?? '', 'seealso']}
                                label={t('seealso')}
                            >
                                <Input  />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'LINK']}
                                fieldKey={[field?.fieldKey ?? '', 'LINK']}
                                label={t('LINK')}
                                extra={t('index_name_example')}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'kohafield']}
                                fieldKey={[field?.fieldKey ?? '', 'kohafield']}
                                label={t('kohafield')}
                                extra={t('edit_koha_to_marc_mapping')}
                                hidden={true}
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>
                        {/* <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'display_order']}
                                fieldKey={[field?.fieldKey ?? '', 'display_order']}
                                label={t('display_order')}
                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'hidden_opac']}
                                fieldKey={[field?.fieldKey ?? '', 'hidden_opac']}
                                label={t('hidden_opac')}
                                labelCol={16}
                                wrapperCol={8}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>

                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'hidden_staff_interface']}
                                fieldKey={[field?.fieldKey ?? '', 'hidden_staff_interface']}
                                label={t('hidden_staff_interface')}
                                labelCol={16}
                                wrapperCol={8}
                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'hidden_editor']}
                                fieldKey={[field?.fieldKey ?? '', 'hidden_editor']}
                                label={t('hidden_editor')}
                                labelCol={16}
                                wrapperCol={8}
                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>

                            <Form.Item
                                {...field}
                                labelCol={16}
                                wrapperCol={8}
                                name={[field?.name ?? '', 'hidden_collapsed']}
                                fieldKey={[field?.fieldKey ?? '', 'hidden_collapsed']}
                                label={t('hidden_collapsed')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Form.Item
                                {...field}
                                labelCol={16}
                                wrapperCol={8}
                                name={[field?.name ?? '', 'hidden_flagged']}
                                fieldKey={[field?.fieldKey ?? '', 'hidden_flagged']}
                                label={t('hidden_flagged')}
                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col>
                                    <Typography.Title level={3}>
                                        {t('other_options_choose_one')}
                                    </Typography.Title>
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'authorised_value']}
                                fieldKey={[field?.fieldKey ?? '', 'authorised_value']}
                                label={t('authorised_value')}
                            >
                                <Select
                                    allowClear={true}
                                    options={parentAuthorisedCategoryOptions.map((value) => {
                                        return {
                                            ...value,
                                            label: `${value?.category}`,
                                            value: value?.category
                                        }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'authtypecode']}
                                fieldKey={[field?.fieldKey ?? '', 'authtypecode']}
                                label={t('authtypecode')}

                            >
                                <Select
                                    allowClear={true}
                                    options={[
                                        { value: "", label: "" },
                                        { value: "CHRON_TERM", label: "CHRON_TERM" },
                                        { value: "CORPO_NAME", label: "CORPO_NAME" },
                                        { value: "GENRE/FORM", label: "GENRE/FORM" },
                                        { value: "GEOGR_NAME", label: "GEOGR_NAME" },
                                        { value: "MEETI_NAME", label: "MEETI_NAME" },
                                        { value: "PERSO_NAME", label: "PERSO_NAME" },
                                        { value: "TOPIC_TERM", label: "TOPIC_TERM" },
                                        { value: "UNIF_TITLE", label: "UNIF_TITLE" }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'value_builder']}
                                fieldKey={[field?.fieldKey ?? '', 'value_builder']}
                                label={t('value_builder')}

                            >
                                <Select
                                    allowClear={true}
                                    options={[
                                        { value: "", label: "選擇條目" },
                                        { value: "barcode.pl", label: "barcode.pl" },
                                        { value: "barcode_manual.pl", label: "barcode_manual.pl" },
                                        { value: "callnumber-KU.pl", label: "callnumber-KU.pl" },
                                        { value: "callnumber.pl", label: "callnumber.pl" },
                                        { value: "cn_browser.pl", label: "cn_browser.pl" },
                                        { value: "dateaccessioned.pl", label: "dateaccessioned.pl" },
                                        { value: "marc21_field_005.pl", label: "marc21_field_005.pl" },
                                        { value: "marc21_field_006.pl", label: "marc21_field_006.pl" },
                                        { value: "marc21_field_007.pl", label: "marc21_field_007.pl" },
                                        { value: "marc21_field_008.pl", label: "marc21_field_008.pl" },
                                        { value: "marc21_field_008_authorities.pl", label: "marc21_field_008_authorities.pl" },
                                        { value: "marc21_field_008_classifications.pl", label: "marc21_field_008_classifications.pl" },
                                        { value: "marc21_field_245h.pl", label: "marc21_field_245h.pl" },
                                        { value: "marc21_field_260b.pl", label: "marc21_field_260b.pl" },
                                        { value: "marc21_leader.pl", label: "marc21_leader.pl" },
                                        { value: "marc21_leader_authorities.pl", label: "marc21_leader_authorities.pl" },
                                        { value: "marc21_linking_section.pl", label: "marc21_linking_section.pl" },
                                        { value: "marc21_orgcode.pl", label: "marc21_orgcode.pl" },
                                        { value: "stocknumber.pl", label: "stocknumber.pl" },
                                        { value: "stocknumberAV.pl", label: "stocknumberAV.pl" },
                                        { value: "stocknumberam123.pl", label: "stocknumberam123.pl" },
                                        { value: "unimarc_field_009_ppn.pl", label: "unimarc_field_009_ppn.pl" },
                                        { value: "unimarc_field_010.pl", label: "unimarc_field_010.pl" },
                                        { value: "unimarc_field_100.pl", label: "unimarc_field_100.pl" },
                                        { value: "unimarc_field_100_authorities.pl", label: "unimarc_field_100_authorities.pl" },
                                        { value: "unimarc_field_105.pl", label: "unimarc_field_105.pl" },
                                        { value: "unimarc_field_106.pl", label: "unimarc_field_106.pl" },
                                        { value: "unimarc_field_110.pl", label: "unimarc_field_110.pl" },
                                        { value: "unimarc_field_115a.pl", label: "unimarc_field_115a.pl" },
                                        { value: "unimarc_field_115b.pl", label: "unimarc_field_115b.pl" },
                                        { value: "unimarc_field_116.pl", label: "unimarc_field_116.pl" },
                                        { value: "unimarc_field_117.pl", label: "unimarc_field_117.pl" },
                                        { value: "unimarc_field_120.pl", label: "unimarc_field_120.pl" },
                                        { value: "unimarc_field_121a.pl", label: "unimarc_field_121a.pl" },
                                        { value: "unimarc_field_121b.pl", label: "unimarc_field_121b.pl" },
                                        { value: "unimarc_field_122.pl", label: "unimarc_field_122.pl" },
                                        { value: "unimarc_field_123a.pl", label: "unimarc_field_123a.pl" },
                                        { value: "unimarc_field_123defg.pl", label: "unimarc_field_123defg.pl" },
                                        { value: "unimarc_field_123i.pl", label: "unimarc_field_123i.pl" },
                                        { value: "unimarc_field_123j.pl", label: "unimarc_field_123j.pl" },
                                        { value: "unimarc_field_124.pl", label: "unimarc_field_124.pl" },
                                        { value: "unimarc_field_124a.pl", label: "unimarc_field_124a.pl" },
                                        { value: "unimarc_field_124b.pl", label: "unimarc_field_124b.pl" },
                                        { value: "unimarc_field_124c.pl", label: "unimarc_field_124c.pl" },
                                        { value: "unimarc_field_124d.pl", label: "unimarc_field_124d.pl" },
                                        { value: "unimarc_field_124e.pl", label: "unimarc_field_124e.pl" },
                                        { value: "unimarc_field_124f.pl", label: "unimarc_field_124f.pl" },
                                        { value: "unimarc_field_124g.pl", label: "unimarc_field_124g.pl" },
                                        { value: "unimarc_field_125.pl", label: "unimarc_field_125.pl" },
                                        { value: "unimarc_field_125a.pl", label: "unimarc_field_125a.pl" },
                                        { value: "unimarc_field_125b.pl", label: "unimarc_field_125b.pl" },
                                        { value: "unimarc_field_126.pl", label: "unimarc_field_126.pl" },
                                        { value: "unimarc_field_126a.pl", label: "unimarc_field_126a.pl" },
                                        { value: "unimarc_field_126b.pl", label: "unimarc_field_126b.pl" },
                                        { value: "unimarc_field_127.pl", label: "unimarc_field_127.pl" },
                                        { value: "unimarc_field_128a.pl", label: "unimarc_field_128a.pl" },
                                        { value: "unimarc_field_128b.pl", label: "unimarc_field_128b.pl" },
                                        { value: "unimarc_field_128c.pl", label: "unimarc_field_128c.pl" },
                                        { value: "unimarc_field_130.pl", label: "unimarc_field_130.pl" },
                                        { value: "unimarc_field_135a.pl", label: "unimarc_field_135a.pl" },
                                        { value: "unimarc_field_140.pl", label: "unimarc_field_140.pl" },
                                        { value: "unimarc_field_141.pl", label: "unimarc_field_141.pl" },
                                        { value: "unimarc_field_146a.pl", label: "unimarc_field_146a.pl" },
                                        { value: "unimarc_field_146b.pl", label: "unimarc_field_146b.pl" },
                                        { value: "unimarc_field_146c.pl", label: "unimarc_field_146c.pl" },
                                        { value: "unimarc_field_146d.pl", label: "unimarc_field_146d.pl" },
                                        { value: "unimarc_field_146e.pl", label: "unimarc_field_146e.pl" },
                                        { value: "unimarc_field_146f.pl", label: "unimarc_field_146f.pl" },
                                        { value: "unimarc_field_146h.pl", label: "unimarc_field_146h.pl" },
                                        { value: "unimarc_field_146i.pl", label: "unimarc_field_146i.pl" },
                                        { value: "unimarc_field_181-2.pl", label: "unimarc_field_181-2.pl" },
                                        { value: "unimarc_field_181a.pl", label: "unimarc_field_181a.pl" },
                                        { value: "unimarc_field_181b.pl", label: "unimarc_field_181b.pl" },
                                        { value: "unimarc_field_181c.pl", label: "unimarc_field_181c.pl" },
                                        { value: "unimarc_field_182-2.pl", label: "unimarc_field_182-2.pl" },
                                        { value: "unimarc_field_182a.pl", label: "unimarc_field_182a.pl" },
                                        { value: "unimarc_field_182c.pl", label: "unimarc_field_182c.pl" },
                                        { value: "unimarc_field_183-2.pl", label: "unimarc_field_183-2.pl" },
                                        { value: "unimarc_field_183a.pl", label: "unimarc_field_183a.pl" },
                                        { value: "unimarc_field_210c.pl", label: "unimarc_field_210c.pl" },
                                        { value: "unimarc_field_210c_bis.pl", label: "unimarc_field_210c_bis.pl" },
                                        { value: "unimarc_field_225a.pl", label: "unimarc_field_225a.pl" },
                                        { value: "unimarc_field_225a_bis.pl", label: "unimarc_field_225a_bis.pl" },
                                        { value: "unimarc_field_283-2.pl", label: "unimarc_field_283-2.pl" },
                                        { value: "unimarc_field_283a.pl", label: "unimarc_field_283a.pl" },
                                        { value: "unimarc_field_325h.pl", label: "unimarc_field_325h.pl" },
                                        { value: "unimarc_field_325j.pl", label: "unimarc_field_325j.pl" },
                                        { value: "unimarc_field_4XX.pl", label: "unimarc_field_4XX.pl" },
                                        { value: "unimarc_field_686a.pl", label: "unimarc_field_686a.pl" },
                                        { value: "unimarc_leader.pl", label: "unimarc_leader.pl" },
                                        { value: "unimarc_leader_authorities.pl", label: "unimarc_leader_authorities.pl" },
                                        { value: "upload.pl", label: "upload.pl" }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};





export default SubfieldStructureManagementForm;
